/* Dhrohar 0.6.0: customer reviews carousel (sections/dhrohar-reviews.liquid).
   A scroll-snap list; the arrow buttons scroll by one card and are disabled at either end. Swipe, trackpad and
   keyboard (the list is focusable; arrow keys scroll) work natively. Reduced motion jumps instead of gliding. */
(() => {
  if (customElements.get('dhrohar-reviews')) return;

  class DhroharReviews extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-dh-reviews-list]');
      const section = this.closest('.dh-reviews');
      this.nav = section && section.querySelector('[data-dh-reviews-nav]');
      if (!this.list || !this.nav) return;
      this.prev = this.nav.querySelector('[data-dh-reviews-prev]');
      this.next = this.nav.querySelector('[data-dh-reviews-next]');
      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      this.list.addEventListener('scroll', () => this.update(), { passive: true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.list);
      this.update();
    }

    disconnectedCallback() {
      this.resize?.disconnect();
    }

    step(direction) {
      const card = this.list.querySelector('.dh-review');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.list.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduce ? 'auto' : 'smooth' });
    }

    update() {
      const max = this.list.scrollWidth - this.list.clientWidth;
      const scrollable = max > 2;
      this.nav.hidden = !scrollable;
      if (!scrollable) return;
      const x = Math.abs(this.list.scrollLeft);
      this.prev.disabled = x <= 2;
      this.next.disabled = x >= max - 2;
    }
  }

  customElements.define('dhrohar-reviews', DhroharReviews);
})();
